<template>
    <div id="banner">
        <VueSlickCarousel v-bind="slickOptions" :arrows="false" :dots="true">
            <div>
                <div class="slide-1">
                    <b-col class="centerv">
                        <h1 class="title-slide">From a restaurant, cafeteria, to an industrial dining room or hotel, we have what you are looking for.</h1>
                    </b-col>
                </div>
            </div>
            <div>
                <div class="slide-2">
                    <b-col class="centerv">
                        <h1 class="title-slide">From a restaurant, cafeteria, to an industrial dining room or hotel, we have what you are looking for.</h1>
                    </b-col>
                </div>
            </div>
            <div>
                <div class="slide-3">
                    <b-col class="centerv">
                        <h1 class="title-slide">From a restaurant, cafeteria, to an industrial dining room or hotel, we have what you are looking for.</h1>
                    </b-col>
                </div>
            </div>
            <div>
                <div class="slide-4">
                    <b-col class="centerv">
                        <h1 class="title-slide">From a restaurant, cafeteria, to an industrial dining room or hotel, we have what you are looking for.</h1>
                    </b-col>
                </div>
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: {
            VueSlickCarousel
        },
        data() {
            return {
                slickOptions: {
                    autoplay: true,
                    autoplaySpeed: 10000,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    speed: 1000,
                }
            }
        }
    }
</script>

<style scoped>
#banner{
    width: 100%;
    min-height: 100vh;
}
#banner .row{
    width: 100%;
    min-height: 100vh;
}
.slide-1,
.slide-2,
.slide-3,
.slide-4{
    min-height: 100vh;
    display: grid;
    background-position: center; 
    background-repeat: no-repeat;
    background-size: cover;
}
.slide-1{
    background-image: url("../assets/img/img_banner1.jpg");
}
.slide-2{
    background-image: url("../assets/img/img_banner2.jpg");
}
.slide-3{
    background-image: url("../assets/img/img_banner3.jpg");
}
.slide-4{
    background-image: url("../assets/img/img_banner4.jpg");
}
.title-slide{
    font-size: 96px !important;
    color: #fff;
    width: 90%;
    line-height: 1;
}
.centerv{
    padding: 6% 5%;
}

@media (max-width: 1600px){
    .title-slide{
        font-size: 75px !important;
    }
}

@media (max-width: 968px){
    .title-slide{
        font-size: 50px !important;
    }
}

@media (max-width: 768px){
    .title-slide{
        font-size: 40px !important;
        width: 100%;
    }
}
</style>